import { render, staticRenderFns } from "./KeuanganCabang.vue?vue&type=template&id=5a9dbfcb"
import script from "./KeuanganCabang.vue?vue&type=script&lang=js"
export * from "./KeuanganCabang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports